import * as React from "react";

interface PropTypes {}

export const PublishedSvg = (props: PropTypes) => (
	<svg
		width={16}
		height={16}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle
			cx={8.48462}
			cy={8.48462}
			r={7.51538}
			fill="url(#paint0_linear_1_3)"
		/>
		<path
			d="M11.0323 11.7743H9.57765H9.18594H9.10135V9.82317H9.73948C9.90131 9.82317 9.99693 9.63928 9.90131 9.50687L8.65999 7.78926C8.58092 7.67892 8.41725 7.67892 8.33817 7.78926L7.09685 9.50687C7.00123 9.63928 7.09501 9.82317 7.25868 9.82317H7.89681V11.7743H7.81222H7.42052H5.73416C4.7687 11.721 4 10.8181 4 9.83973C4 9.16482 4.36596 8.57634 4.90846 8.2582C4.85881 8.12395 4.83306 7.98051 4.83306 7.82971C4.83306 7.14009 5.39027 6.58288 6.07989 6.58288C6.22885 6.58288 6.37229 6.60863 6.50654 6.65828C6.9056 5.81234 7.76624 5.22571 8.76665 5.22571C10.0613 5.22755 11.1279 6.21876 11.2493 7.48214C12.2442 7.65317 13 8.5745 13 9.61721C13 10.7316 12.132 11.6971 11.0323 11.7743Z"
			fill="white"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_1_3"
				x1={8.48462}
				y1={17.4091}
				x2={8.48462}
				y2={2.37837}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#8A00FF" />
				<stop offset={1} stopColor="#AF6FFF" />
			</linearGradient>
		</defs>
	</svg>
);
